import JournalgroupModel from '../journalgroup/journalgroup-model';
import OwnerModel from '../owner/owner-model';

export default class AmounttypeModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    calc: string;       
    calcsign: number;
    aspercentage: boolean;
    value: number;
    journalgroup: any;
    journalgroupCaption: string;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.calc = datarow.calc || 'increase';
        this.calcsign = this.calc.startsWith('increase')? 1 : -1;
        this.aspercentage = AmounttypeModel.asPercentage(this.calc);
        this.value = datarow.value;
        let journalgroup = datarow.journalgroup?.data? new JournalgroupModel(datarow.journalgroup?.data) : datarow.journalgroup;
        this.journalgroup = journalgroup?.id;
        this.journalgroupCaption = journalgroup?.name;
    } 

    public static endPoint: string = 'amount-types' 
    public static endPointFilterList = () => {
       const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' +owner);
    } 
    public static url: string = '/amounttype';
    public static caption: string = 'Amount Type';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),
        calc: 'increase',
        calcsign: 1,
        aspercentage: false,
        value: 0,
        journalgroup: null,
        journalgroupCaption: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'value', caption: 'Value', type: 'money' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'value', caption: 'Value', type: 'money' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionCalc = [
        { name: 'increase', caption: 'Increase' },
        { name: 'increase-aspercentage', caption: 'Increase - As Percentage' },
        { name: 'decrease', caption: 'Decrease' },
        { name: 'decrease-aspercentage', caption: 'Decrease - As Percentage' },
    ]

    public static asPercentage(calc: string) { 
        return calc.includes('-aspercentage');
    }

    public static getCalcValue(aspercentage: boolean, value: number, valuebase: number) { 
        return aspercentage? valuebase * value / 100 :  value;
    }

}